import { render, staticRenderFns } from "./StaticPop.vue?vue&type=template&id=85322d4e&scoped=true"
import script from "./StaticPop.vue?vue&type=script&lang=js"
export * from "./StaticPop.vue?vue&type=script&lang=js"
import style0 from "./StaticPop.vue?vue&type=style&index=0&id=85322d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85322d4e",
  null
  
)

export default component.exports